import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=12479a17&scoped=true"
import script from "./AccountDetail.vue?vue&type=script&lang=js"
export * from "./AccountDetail.vue?vue&type=script&lang=js"
import style0 from "./AccountDetail.vue?vue&type=style&index=0&id=12479a17&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12479a17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12479a17')) {
      api.createRecord('12479a17', component.options)
    } else {
      api.reload('12479a17', component.options)
    }
    module.hot.accept("./AccountDetail.vue?vue&type=template&id=12479a17&scoped=true", function () {
      api.rerender('12479a17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/accounts/AccountDetail.vue"
export default component.exports